import React from 'react'
import { FilterParam, FilterName } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

interface AccessRoleFilterDropdownProps {
  isNested?: boolean
}

export const AccessRoleFilterDropdown: React.FC<
  AccessRoleFilterDropdownProps
> = ({ isNested }) => {
  return (
    <GenericFilterDropdown
      filterParam={FilterParam.ACCESS_ROLE}
      filterName={FilterName.ACCESS_ROLE}
      valueKey="accessRoles"
      isNested={isNested}
    />
  )
}
